import { useRouter } from 'next/router';
import { MdQrCode } from 'react-icons/md';
import { PATH_NAME } from '../../configs/pathName';

const QRScanButton: React.FC = () => {
  const router = useRouter();

  return (
    <div
      onClick={() => router.push(`${PATH_NAME.SCAN_QR}?destinationTab=2`)}
      className="flex flex-col text-primary text-center justify-between items-center cursor-pointer z-[90]"
    >
      <MdQrCode size={23} />
      <p className="sm:text-sm">Quét QR</p>
    </div>
  );
};

export default QRScanButton;
